import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbFormWithPersonalInfoInterface } from '../interfaces/eb-common-form.interface'

@Injectable({
  providedIn: 'root'
})
export class EbPersonalInfoConverter implements Converter<any, EbFormWithPersonalInfoInterface> {
  convert(source: any, target?: EbFormWithPersonalInfoInterface): EbFormWithPersonalInfoInterface {
    if (source === undefined) {
      return {} as EbFormWithPersonalInfoInterface
    }

    if (target === undefined) {
      target = {} as EbFormWithPersonalInfoInterface
    }
    target.personalInfo = {
      ...source.personalInfo,
      customerNumberUnknown: !!source.personalInfo.customerNumberUnknown
    }
    return target
  }
}
